export default __webpack_public_path__ + "f0216f0655d9c9007122e7be37996288.png";